import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import qs from 'qs';
import { PORTAL_COMMISSIONS_QUERY } from './graphql'
import Card from './Card';
import Header from './Header';

class Commissions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            skip: 0,
            initialPage: 0,
            refetch: false
        };

        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleCompletedFetching = this.handleCompletedFetching.bind(this);
    }

    componentDidMount() {
        const params =  qs.parse(window.location.search, {
            ignoreQueryPrefix: true
        });
        const { p: page } = params;
        const initialPage = (page) ? page-1 : 0;
        const skip = (initialPage > 0) ? page * 20 : 0;
        this.setState({
            skip,
            initialPage
        });
    }

    handleCompletedFetching() {
        this.setState({
            refetch: false
        });
    }

    toggleRefetch() {
        const { refetch } = this.props;
        this.setState({
            refetch: !refetch
        });
    }

    handlePageClick = data => {
        const { selected } = data;
        const skip = Math.ceil(selected * 20);
        const initialPage = selected;
        this.setState({
            skip,
            initialPage
        });
        this.props.history.push({
            pathname: '/comissoes',
            search: "?" + new URLSearchParams({
                p: (selected+1)
            }).toString()
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.refetch && !prevState.refetch) {
            this.setState({
                refetch: false
            });
        }

        if (JSON.stringify(this.props.filters) !== JSON.stringify(prevProps.filters)) {
            this.setState({
                refetch: true
            });
        }
    }

    render() {
        const first = 20;
        const { operatorId, filters } = this.props;
        const { skip, initialPage } = this.state;
        const variables = {
            operatorId,
            skip,
            first,
            ...filters
        };

        return (
            <Query
                query={PORTAL_COMMISSIONS_QUERY}
                variables={variables}
                notifyOnNetworkStatusChange
            >
                {({ loading, error, data, refetch }) => {

                    if (this.state.refetch) {
                        refetch();
                    }

                    const { portalCommissions } = data || {};

                    return (
                        <Fragment>
                            <Header
                                loading={loading}
                                error={error}
                                data={portalCommissions}
                            />
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <Card
                                            loading={loading}
                                            error={error}
                                            data={portalCommissions}
                                            filters={filters}
                                            operatorId={operatorId}
                                            initialPage={initialPage}
                                            onPageClick={this.handlePageClick}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    );
                }}
            </Query>
        );
    }
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId,
    filters: state.commissions.filters
});

export default connect(mapStateToProps)(Commissions);



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/index.js